import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';

/**
 * Called when there is a change in the birthday calendar enabled option
 */

export default mutatorAction('updateBirthdayCalendarInitialState', function(
    birthdayCalendarEnabled: boolean
) {
    let optionState = getStore();
    optionState.birthdayCalendarEnabledInitial = birthdayCalendarEnabled;
});
